export default __webpack_public_path__ + "static/media/wireControl.7df8832b.png";